import { initTextToggle } from '../../utils';

const MainHeader = () => initTextToggle('mainHeader');

export default MainHeader;
